module.exports = __webpack_public_path__ + "static/media/test.1121f8f4.jpg";